{
  "page_count": "af {n, plural, one{# side} other{# sider}}"
}
